import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.dataChildDepartment.loading;
export const selectErrorMessage = (state: RootState) =>
  state.dataChildDepartment.error;
export const dataChildDepartmentResponse = (state: RootState) =>
  state.dataChildDepartment.dataChildDepartmentResponse;
